<template>
  <div class="users__comments">
    <v-card>
      <div>
        <v-toolbar flat color="white">
          <v-tabs v-model="tab">
            <v-tab :key="0">По Банкам</v-tab>
            <v-tab :key="1">По Сайтам</v-tab>
            <v-spacer></v-spacer>
            <v-text-field
              style="top: 10px; position: relative"
              v-model="search"
              append-icon="search"
              clearable
              label="Поиск ..."
              single-line
            />
            <v-spacer></v-spacer>
          </v-tabs>
        </v-toolbar>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          bottom
          color="deep-purple accent-4"
        />
      </div>
      <Banks
        :desserts="sortDesserts"
        @removeComment="removeComment($event)"
        v-if="tab == 0 && desserts !== null"
      />
      <Sites
        :desserts="sortDesserts"
        @removeComment="removeComment($event)"
        v-if="tab == 1 && desserts !== null"
      />
    </v-card>
  </div>
</template>
<script>
import Banks from "./UserComments/bank.vue";
import Sites from "./UserComments/site.vue";
export default {
  name: "users__comments",
  components: {
    Banks,
    Sites,
  },
  data: () => ({
    loading: true,
    search: "",
    tab: null,
    headers: [{ id: 0, name: "" }],
    desserts: [],
  }),
  computed: {
    sortDesserts() {
      if (this.search) {
        const reg = new RegExp(this.search, "gim");
        if (this.desserts.length > 0) {
          if (this.tab == 0) {
            return Object.assign([], this.desserts).filter((item) => {
              if (reg.test(item.bank.name)) {
                return true;
              } else if (reg.test(item.comment)) {
                return true;
              } else if (reg.test(item.created_at)) {
                return true;
              } else if (reg.test(item.updated_at)) {
                return true;
              } else if (reg.test(item.product.name)) {
                return true;
              } else if (reg.test(item.user.name)) {
                return true;
              } else if (reg.test(item.user.email)) {
                return true;
              } else {
                return false;
              }
            });
          } else {
            return Object.assign([], this.desserts).filter((item) => {
              if (reg.test(item.site.name)) {
                return true;
              } else if (reg.test(item.comment)) {
                return true;
              } else if (reg.test(item.created_at)) {
                return true;
              } else if (reg.test(item.updated_at)) {
                return true;
              } else if (reg.test(item.user.name)) {
                return true;
              } else if (reg.test(item.user.email)) {
                return true;
              } else {
                return false;
              }
            });
          }
        } else {
          return this.desserts;
        }
      } else {
        return this.desserts;
      }
    },
  },
  methods: {
    async removeComment(item) {
      if (this.tab == 0) {
        const payload = {
          bank_id: item.bank_id,
          product_id: item.product_id,
          user_id: item.user_id,
        };
        await this.$store.dispatch("REMOVE_USER_RATE_FROM_BANK", payload);
        this.init();
      } else if (this.tab == 1) {
        const payload = {
          site_id: item.site_id,
          user_id: item.user_id,
        };
        await this.$store.dispatch("REMOVE_USER_RATE_FROM_SITE", payload);
        this.init();
      }
    },
    async BanksComments() {
      this.loading = true;
      const data = await this.$store.dispatch("ALL_BANKS_COMMENTS");
      this.desserts = data;
      this.loading = false;
    },
    async SitesComments() {
      this.loading = true;
      const data = await this.$store.dispatch("ALL_SITES_COMMENTS");
      this.desserts = data;
      this.loading = false;
    },
    async getUsersComments() {
      await this.BanksComments();
    },
    async init() {
      this.search = ''

      if (this.tab == 0) {
        await this.BanksComments();
      }
      if (this.tab == 1) {
        await this.SitesComments();
      }
    },
  },
  async mounted() {
    // await this.getUsersComments()
    this.tab = localStorage.getItem('ADMIN_users_comment') ? parseInt(localStorage.getItem('ADMIN_users_comment')) : 0
  },
  watch: {
    async tab() {
      localStorage.setItem('ADMIN_users_comment',this.tab)
      this.init();
    },
  },
};
</script>
<style lang="sass" scoped>
</style>
